import React from 'react'

const Code = (props) => {
  return (
    <pre {...props.attributes} style={{ overflow: 'scroll' }}>
      <code>{ props.content }</code>
    </pre>
  )
}

export default Code



// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/rich_text/code/index.js